import React from "react";
import { Check, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

const DOT = { bad: "bg-[hsl(var(--v-blocked))]", warn: "bg-[hsl(var(--v-assumed))]", ok: "bg-[hsl(var(--v-ok))]" };
const KIND = { konflikt: "Konflikt", utloper: "Reservasjon", fag: "Kapasitet" };

/** What a person has to decide in this horizon – conflicts, expiring reservations, department-weeks over the line. One list, worst first. */
export function Beslutninger({ items, onPick, limit, testId = "plan-beslutninger" }) {
  const rows = (items || []).slice(0, limit || undefined);
  if (!items) return <div className="h-24 animate-pulse rounded-[12px] bg-black/[0.03]" />;
  if (!rows.length) {
    return (
      <div className="flex items-center gap-3 rounded-[14px] bg-[hsl(var(--v-ok-bg))] px-4 py-3 text-[13.5px] text-[hsl(var(--v-ok))]" data-testid={`${testId}-empty`}>
        <Check className="h-4 w-4 shrink-0" strokeWidth={2.4} /> Ingenting venter på beslutning i perioden.
      </div>
    );
  }
  return (
    <ol className="divide-y divide-black/[0.05]" data-testid={testId}>
      {rows.map((b, i) => (
        <li key={`${b.kind}-${i}`}>
          <button type="button" onClick={() => onPick?.(b)} className="group flex w-full items-start gap-3 py-2.5 text-left outline-none transition-colors hover:bg-black/[0.02] focus-visible:ring-2 focus-visible:ring-ring/40 rounded-[8px] -mx-1 px-1" data-testid={`${testId}-${i}`} data-kind={b.kind} data-tone={b.tone}>
            <span className={cn("mt-[7px] h-2 w-2 shrink-0 rounded-full", DOT[b.tone] || "bg-black/20")} />
            <span className="min-w-0 flex-1">
              <span className="block text-[13.5px] font-medium leading-snug text-foreground">{b.tittel}</span>
              <span className="block truncate text-[12px] text-muted-foreground">{KIND[b.kind]}{b.tekst ? ` · ${b.tekst}` : ""}</span>
            </span>
            <ChevronRight className="mt-1 h-4 w-4 shrink-0 text-muted-foreground/50 transition-transform group-hover:translate-x-0.5" />
          </button>
        </li>
      ))}
      {limit && items.length > limit ? <li className="pt-2 text-[12px] text-muted-foreground" data-testid={`${testId}-more`}>+ {items.length - limit} til</li> : null}
    </ol>
  );
}
